<template>
  <section class="container">
    <div class="header">
      根据停车场管理规定，需要您上传证件进行审核，审核通过后方可进行包月操作。
    </div>
    <div class="content">
      <van-uploader>
        <van-image width="100%" height="auto" :src="positive" />
        <van-image width="100%" height="auto" :src="negative" />
      </van-uploader>
    </div>
    <div class="btn_box">
      <van-button @click="submit" size="large" class="blue-btn">
        确认提交
      </van-button>
    </div>
  </section>
</template>

<script>
import { Uploader } from 'vant'
import positive from '@/assets/user_images/positive.png'
import negative from '@/assets/user_images/negative.png'
export default {
  name: 'Certificates',
  components: {
    [Uploader.name]: Uploader
  },
  data () {
    return {
      positive,
      negative
    }
  },
  methods: {
    submit () {
      this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  .header {
    height: 100px;
    padding: 0 15px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    font-size: 16px;
    font-family: SourceHanSansCN-Bold;
    font-weight: bold;
    line-height: 26px;
  }
  .content {
    padding: 0 15px 0;
    margin-bottom: 20px;
  }
  .btn_box {
    padding: 0 15px 0;
  }
}
</style>
